const answerLetters = {
  a: "answer0000",
  b: "answer0001",
  c: "answer0002",
  d: "answer0003",
  e: "answer0004",
  f: "answer0000",
  g: "answer0001",
  h: "answer0002",
  j: "answer0003",
  k: "answer0004",
  A: "answer0000",
  B: "answer0001",
  C: "answer0002",
  D: "answer0003",
  E: "answer0004",
  F: "answer0000",
  G: "answer0001",
  H: "answer0002",
  J: "answer0003",
  K: "answer0004",
}

export default answerLetters


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/answerLetters.js